import { z } from "zod";

/**
 * BAĞLI SÖZLEŞME (CLOS-253 `[161]`).
 *
 * ⚠ Ek protokol, tadil ve yenileme kaynak sözleşmenin YENİ VERSİYONU DEĞİL: kendi kimliği,
 * kendi versiyon zinciri ve kendi yaşam döngüsü olan ayrı sözleşmelerdir. Versiyon zincirine
 * eklesek imzalanmış bir metin sonradan değişmiş gibi görünürdü.
 */
export const CONTRACT_LINK_TYPES = ["addendum", "amendment", "renewal"] as const;
export type ContractLinkType = (typeof CONTRACT_LINK_TYPES)[number];

export const CONTRACT_LINK_TYPE_NAMES: Record<ContractLinkType, string> = {
  addendum: "Ek protokol",
  amendment: "Tadil",
  renewal: "Yenileme",
};

/** Kopyalanabilir alan kümesi — istek bunların dışına çıkamıyor. */
export const CONTRACT_LINK_COPY_FIELDS = ["parties", "metadata"] as const;
export type ContractLinkCopyField = (typeof CONTRACT_LINK_COPY_FIELDS)[number];

export const createLinkedContractSchema = z.strictObject({
  linkType: z.enum(CONTRACT_LINK_TYPES, { message: "Geçerli bir ilişki türü seçilmelidir" }),
  title: z.string().trim().min(1, "Başlık zorunludur").max(300, "Başlık en fazla 300 karakter"),
  /**
   * Kopyalama İSTEĞE BAĞLI (kartın runtime kuralı): kopyalanmayan alan hedef kaydın
   * oluşturulmasını engellemiyor.
   */
  copyFields: z.array(z.enum(CONTRACT_LINK_COPY_FIELDS)).default([]),
});
export type CreateLinkedContractInput = z.infer<typeof createLinkedContractSchema>;

export type ContractLinkSummary = {
  id: string;
  linkType: ContractLinkType;
  sourceContractId: string;
  /** İmza TEMEL versiyonu — ek protokolün dayandığı değişmez metin. */
  sourceVersionId: string;
  targetContractId: string;
  /** Kopyalanan alanların kaynak haritası; canlı bağ DEĞİL, o anın fotoğrafı. */
  copiedFields: string[];
  createdByName: string;
  createdAt: string;
  /** ⚠ Erişimi olmayana `null`: karşı kaydın başlığı sızdırılmıyor. */
  sourceTitle: string | null;
  counterpartTitle: string | null;
};
